
export default function Footer() {
  return (
    <footer id="contacto" className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-4 gap-12">
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-bold mb-6" style={{ fontFamily: 'Pacifico, serif' }}>
              Dr. Eduardo Cabeza Bucio - Urólogo en Guadalajara
            </h3>
            <p className="text-gray-300 mb-6 leading-relaxed">
              Especialista en cirugía láser urológica con más de 10 años de experiencia. 
              Ofrecemos tratamientos de vanguardia con tecnología para 
              garantizar los mejores resultados a nuestros pacientes.
            </p>
            
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/eduardocabezaurologo/videos/" className="w-10 h-10 rounded-full flex items-center justify-center hover:opacity-80 transition-colors cursor-pointer" style={{ backgroundColor: '#168B98' }}>
                <i className="ri-facebook-fill text-white"></i>
              </a>
              <a href="https://x.com/drecabeza" className="w-10 h-10 rounded-full flex items-center justify-center hover:opacity-80 transition-colors cursor-pointer" style={{ backgroundColor: '#1A1A1A' }}>
                <i className="ri-twitter-fill text-white"></i>
              </a>
              <a href="https://www.instagram.com/eduardocabezaurologo/" className="w-10 h-10 bg-pink-600 rounded-full flex items-center justify-center hover:bg-pink-700 transition-colors cursor-pointer">
                <i className="ri-instagram-fill"></i>
              </a>
              <a href="https://api.whatsapp.com/send/?phone=523317097105&text&type=phone_number&app_absent=0" className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center hover:bg-green-700 transition-colors cursor-pointer">
                <i className="ri-whatsapp-fill"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-6">Servicios</h4>
            <ul className="space-y-3">
              <li>
                <a href="#tratamientos" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Cirugía Urológica de Próstata
                </a>
              </li>
              <li>
                <a href="#tratamientos" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Cirugía Urológica de Riñón
                </a>
              </li>
              <li>
                <a href="#tratamientos" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Tratamiento Disfunción Eréctil
                </a>
              </li>
              <li>
                <a href="#papiloma-center" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Papiloma Center - VPH
                </a>
              </li>
              <li>
                <a href="#tratamientos" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Cirugía Láser Urológica
                </a>
              </li>
              <li>
                <a href="#tratamientos" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Cirugía Uro Reconstructiva
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-6">Contacto</h4>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-map-pin-line mr-3 mt-1" style={{ color: '#168B98' }}></i>
                <div>
                  <p className="text-gray-300">
                    Calle General Eulogio Parra 2969,<br />Prados Providencia,<br />Guadalajara, Jalisco
                  </p>
                </div>
              </div>
              
              <div className="flex items-center">
                <i className="ri-phone-line mr-3" style={{ color: '#168B98' }}></i>
                <a href="tel:+523317097105" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  +52 33 1709 7105
                </a>
              </div>
              
              <div className="flex items-center">
                <i className="ri-whatsapp-line text-green-400 mr-3"></i>
                <a href="https://wa.me/523317097105" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  WhatsApp: +52 33 1709 7105
                </a>
              </div>
               
              <div className="flex items-start">
                <i className="ri-time-line mr-3 mt-1" style={{ color: '#168B98' }}></i>
                <div className="text-gray-300">
                  <p>Lunes a Viernes: 9:00 AM - 6:00 PM</p>
                  <p>Sábados: 9:00 AM - 2:00 PM</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2024 Dr. Eduardo Cabeza Bucio - Especialista en Cirugía Urologíca. Todos los derechos reservados.
            </div>
            <div className="flex items-center space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                Políticas de Privacidad
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                Términos y Condiciones
              </a>
              <a href="https://citadoctor.com.mx" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                Hecho por CitaDoctor
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
